import { socket } from "@/shared/config/socket";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useResizeDetector } from "react-resize-detector";
import { AppDispatch } from "../../store";
import TheAside from "./TheAside";
import TheContent from "./TheContent";
import TheHeader from "./TheHeader";
import TheSidebar from "./TheSidebar";
import { setBodyWidth } from "./reducer";

const TheLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { ref: bodyRef, width: bodyWidth } = useResizeDetector();

  useEffect(() => {
    dispatch(setBodyWidth(bodyWidth || 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bodyWidth]);

  return (
    <div>
      <TheAside />
      <TheSidebar />
      <div
        className="wrapper d-flex flex-column min-vh-100 bg-light"
        ref={bodyRef}
      >
        <TheHeader />

        <div className="body flex-grow-1">
          <TheContent />
        </div>
      </div>
    </div>
  );
};
export default TheLayout;
